import { lazy } from "react";

export const PatientsAsync = lazy(() => import("./Patients"));
